import(/* webpackMode: "eager" */ "/codebuild/output/src1770170836/src/ui-directo/apps/prospects/src/app/(loginLayout)/login/page.tsx");
